import axios from 'axios';

const baseURL = `api/mountingmaterial`;

export default {
    getMountingMaterialCharacteristics() {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(baseURL);
    },
    // Returns LLT Characteristics for main parent Characteristics
    getChildCharacteristicsByParentCharacteristicCodes(parentsCharacteristicsCodes: string[]) {
        // return service.http.post(baseURL, parentsCharacteristicsCodes);
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.post(baseURL, JSON.stringify(parentsCharacteristicsCodes), { headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type': 'application/json',
        }});
    },
};
